import { render, staticRenderFns } from "./language-switcher.vue?vue&type=template&id=48620896"
import script from "./language-switcher.vue?vue&type=script&lang=js"
export * from "./language-switcher.vue?vue&type=script&lang=js"
import style0 from "./language-switcher.vue?vue&type=style&index=0&id=48620896&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports